import React from "react";
import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import { carouselContainer } from './style';
import gambar1 from '../../assets/img1.png'
import gambar2 from '../../assets/img2.png'
import gambar3 from '../../assets/img3.png'

const Header = () => (
    <div className={carouselContainer}>
      <Carousel>
        <Carousel.Item className="itemnya">
          <img
            className="d-block w-100 ngetestHover"
            src={gambar1}
            alt="First slide"
          />
        </Carousel.Item>
        <Carousel.Item className="itemnya">
          <img
            className="d-block w-100"
            src={gambar2}
            alt="Third slide"
          />
        </Carousel.Item>
        <Carousel.Item className="itemnya">
          <img
            className="d-block w-100"
            src={gambar3}
            alt="Third slide"
          />
        </Carousel.Item>
      </Carousel>
    </div>
)

export default Header;